module.exports = __webpack_public_path__ + "img/happytable_product4.4c9fd16f.jpg";